import fieldRenderers from './fields'
import { resolveFieldType } from './fields/fieldHelpers'

export function FormSelector(
    translate,
    item,
    onChange,
    helpertextcardtype,
    formattedValue,
    onKeyUp,
    forceType = '',
    pickupShippingFormDetail,
    allItems = []
) {
    if (!item) return null

    const fieldType = resolveFieldType(forceType, item)
    const render = fieldRenderers[fieldType] || fieldRenderers.default

    const context = {
        translate,
        item,
        onChange,
        helpertextcardtype,
        formattedValue,
        onKeyUp,
        forceType,
        pickupShippingFormDetail,
        allItems
    }

    return render(context)
}
